<template>
  <div class="d-flex flex-column h-100">
    <div class="content-header-card chart header-position">
      <div class="content-header-name d-flex justify-content-between w-100">
        <div>{{ renderData.card_name }}</div>
        <div>
          <img
            v-if="renderData.tooltip"
            :src="Tooltip"
            class="tooltip-img"
            v-b-tooltip.hover.bottomleft.html
            :title="renderData.tooltip"
          />
        </div>
      </div>
    </div>
    <div v-if="renderData.data.length > 0" class="content-body-card">
      <div id="dynamic-table" class="data-table-body-card">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :items="renderData.data"
              :fields="renderData.fields"
              responsive
              bordered
              borderless
              show-empty
              no-local-sorting
              class="dynamic-table"
              tbody-tr-class="custom-tr"
            >
              <template
                v-for="col in renderData.fields"
                v-slot:[renderHead(col.key)]
              >
                <span
                  :key="col.key + 'head'"
                  class="d-flex justify-content-around data-table-header"
                >
                  {{ col.label }}</span
                >
              </template>
              <template
                v-for="col in renderData.fields"
                v-slot:[renderCell(col.key)]="data"
              >
                <div
                  :key="col.key + data.value + 'imgmedal'"
                  class="d-flex justify-content-center"
                >
                  <img
                    v-if="col.key == 'seq' && resolveShowMedal(data.value)"
                    :src="resolveMedalImg(data.value)"
                    class="d-flex justify-content-center data-table-col-img-seq"
                  />
                </div>
                <div
                  :key="col.key + data.value + 'image'"
                  class="d-flex justify-content-center"
                >
                  <b-img
                    v-if="col.key == 'image'"
                    :src="data.value || DefaulData.Img"
                    class="d-flex justify-content-around data-table-col-img"
                    :class="{ 'rounded-circle': DefaulData.rounded }"
                  />
                </div>
                <div
                  v-if="resolveNotShowText(col.key, data.value)"
                  :key="col.key + 'value'"
                  class="d-flex justify-content-around data-table-col-text"
                >
                  {{ data.value }}
                </div>
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" :height="100" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </div>
    </div>
    <div v-else class="content-body-card h-100">
      <card-no-item :textNoImg="'Item Not Found'" :height="100" />
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import NoPicture from "@/assets/images/icons/nopicture.png";
import CrmNoImg from "@/assets/images/icons/IconProfile.png";
import MedalGold from "@/assets/images/icons/medalGold.png";
import MedalSilver from "@/assets/images/icons/medalSilver.png";
import MedalCopper from "@/assets/images/icons/medalCopper.png";
import Tooltip from "@/assets/images/icons/Tooltip.png";

import { reactive, onMounted, ref } from "@vue/composition-api";
import { formatter } from "@/utils/scripts/format-currency";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  components: {
    CardNoItem,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: () => [] },
    keyid: Object,
    dynamicTableConfig: Object,
    BrandAppDetail: Object,
  },
  setup(props) {
    const { openDefaultErrorModal } = useValidationModal();

    const { fetchQueryDataModel } = dynamicTableModel();

    const loading = reactive({
      tableData: false,
    });

    const renderData = reactive({
      card_name: "",
      keyid: "",
      tooltip: "",
      fields: [],
      data: [],
    });

    const DefaulData = reactive({
      Img: "",
      rounded: "",
    });

    const rounded = ref("circle");

    const renderCell = (key) => `cell(${key})`;

    const renderHead = (key) => `head(${key})`;

    const setData = () => {
      if (props.keyid.query_data_key == "DashboardTopPrivilege") {
        DefaulData.Img = NoPicture;
        DefaulData.rounded = false;
      } else {
        DefaulData.Img = CrmNoImg;
        DefaulData.rounded = true;
      }
    };

    const resolveShowMedal = (seq) => {
      switch (seq) {
        case 1:
          return true;
        case 2:
          return true;
        case 3:
          return true;
        default:
          return false;
      }
    };

    const resolveNotShowText = (key, data) => {
      if (key == "image") {
        return false;
      } else if (key == "seq") {
        switch (data) {
          case 1:
            return false;
          case 2:
            return false;
          case 3:
            return false;
          default:
            return true;
        }
      } else {
        return true;
      }
    };

    const resolveMedalImg = (seq) => {
      switch (seq) {
        case 1:
          return MedalGold;
        case 2:
          return MedalSilver;
        case 3:
          return MedalCopper;
      }
    };

    const fetchSummaryDetail = () => {
      loading.tableData = false;

      const payload = {
        QueryData_Key: props.keyid.query_data_key,
        Query_Data_Key_Type: props.keyid.query_data_key_type,
        Display_Key: props.dynamicTableConfig.displayKey,
        Display_ChartId: props.keyid.display_chartid,
      };

      fetchQueryDataModel.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataModel)
        .then((response) => {
          const respData = response.data.payload.find(
            (o) => o.keyid == props.keyid.query_data_key
          );
          renderData.card_name = respData.card_name;
          renderData.keyid = respData.keyid;
          renderData.tooltip = respData.tooltip;
          renderData.fields = respData.fields;
          renderData.data = respData.data;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.tableData = false;
        });
    };

    onMounted(() => {
      setData();
      fetchSummaryDetail();
    });

    return {
      loading,
      Tooltip,
      MedalGold,
      MedalSilver,
      MedalCopper,
      DefaulData,
      rounded,
      formatter,
      renderData,
      renderHead,
      renderCell,
      resolveMedalImg,
      resolveShowMedal,
      resolveNotShowText,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/dynamic-tables.css";
@import "~@/assets/css/pages/data-management/summary-dashboard.css";

.custom-tr {
  height: 70px !important;
  /* display: flex !important;
    justify-content: center !important; */
}
</style>

<style scoped>
.data-table-card {
  border-radius: 1.428rem;
}

.dynamic-table {
  min-height: 100% !important;
  width: 100% !important;
}

.data-table-header {
  font-size: 17px;
}

.data-table-col-img-seq {
  height: 45px;
}

.data-table-col-img {
  height: 40px;
}

.data-table-col-text {
  color: #737373;
  display: inline-block;
  white-space: nowrap;
}

.header-position {
  padding: 1.5rem !important;
}
</style>
